import React from 'react';
import styled from 'styled-components';

const MobileTeamLeaderExperience: React.FC = () => (
  <PageWrapper>
    <PageTitle>Team Leader Mobile</PageTitle>
    <PageText>
      This is the mobile experience for team leaders. Use the menu to navigate your team’s knowledge base, leaderboard, glossary, and culture hub dashboard.
    </PageText>
  </PageWrapper>
);

export default MobileTeamLeaderExperience;

const PageWrapper = styled.div`
  display: grid;
  gap: 16px;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  margin: 0;
  color: #111827;
`;

const PageText = styled.p`
  font-size: 16px;
  color: #475569;
  line-height: 1.6;
`;
